import React from 'react'
import HairTreatmentNearMeHead from './HairTreatmentNearMeHead'
import HairTreatmentNearMePara from './HairTreatmentNearMePara'
import "../NearMe.css";

const HairTreatmentNearMeMain = () => {
  return (
    <div className="nearContainer">
    <HairTreatmentNearMeHead />
    <HairTreatmentNearMePara />
  </div>
  )
}

export default HairTreatmentNearMeMain
